import { locale } from '../../Services/Tools/reducers';

export const contracts = {
  strings: locale('fr', 'contracts'),
  loading: {
    isLoadingContracts: false,
    isLoadingContract: false,
    isLoadingContractEvents: false,
    isLoadingContractDocuments: false,
    isLoadingContractAttachments: false,
    isLoadingContractBeneficiaries: false,
    isLoadingContractStatus: false,
    isUpdatingContractDocuments: false,
    isSubmittingContract: false,
  },
  alerts: {
    errors: [],
    warnings: [],
    infos: [],
    successes: [],
  },
  filters: {},
};
